/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const StopCircle = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "12", r: "10" }],
    ["rect", { width: "6", height: "6", x: "9", y: "9" }]
  ]
];

export { StopCircle as default };
//# sourceMappingURL=stop-circle.js.map
